/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import { SpeakersType, TranscriptDataProps, Segment } from '../types';

const TRANSCRIPTION_RETRY_DELAY = 12 * 60 * 60 * 1000; // 12 hours

export const canRequestTranscriptMaybeAgain = ({
  transcriptUrl,
  transcriptRequestedAt,
}: TranscriptDataProps = {}) => {
  if (transcriptUrl) return false;
  if (!transcriptRequestedAt) return true;
  if (
    transcriptRequestedAt &&
    new Date().getTime() - new Date(transcriptRequestedAt).getTime() >
      TRANSCRIPTION_RETRY_DELAY
  ) {
    return true;
  }

  return false;
};

interface GetCopiableTranscriptOptions {
  segments: Segment[];
  speakers?: SpeakersType;
}

export const formatSegmentTime = (time: number) => {
  const duration = moment.duration(time, 'seconds');
  const hours = Math.floor(duration.asHours());
  // const seconds = duration.seconds();

  if (hours > 0) {
    return moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
  }
  return moment.utc(duration.asMilliseconds()).format('mm:ss');
};

export const parseSegmentTime = (timeString: string): number => {
  // "[xx.xx.xx]" -> to seconds
  const trimmed = timeString.replace(/\[|\]/g, '');
  const [hours, minutes, seconds] = trimmed.split(':').map(Number);
  return moment.duration({ hours, minutes, seconds }).asSeconds();
};

export const getCopiableTranscript = ({
  segments,
  speakers,
}: GetCopiableTranscriptOptions): string => {
  return segments.reduce((acc, segment) => {
    const { start, end, text, speaker } = segment;
    const speakerName = (speaker && speakers?.[speaker]?.name) || speaker;
    return `${acc}${speakerName} (${formatSegmentTime(
      start
    )} - ${formatSegmentTime(end)}): ${text} \n`;
  }, '');
};
